
import React, { Component } from 'react';
import './canvas.scss'
import GeometryUtility from '../geometry/geometry-utilities'
class CanvasPreview extends Component {
    state = {}
    componentDidUpdate() {
        var canvas = document.getElementById(this.props.id);
        var ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.textBaseline = 'middle'
        this.loadCanvasData(ctx)
    }

    loadCanvasData(ctx) {
        for (let i = 0; i < this.props.coordinates.length; i++) {
            this.drawByCoordinates(ctx, this.props.coordinates[i])
        }
    }

    createCircle(ctx, coordinates) {
        let [startPoint, endPoint] = coordinates.points
        ctx.beginPath();
        ctx.arc(startPoint.x, startPoint.y, 20, 5, 2 * Math.PI);
        ctx.stroke();
    }

    drawByCoordinates(ctx, coordinates) {
        if (coordinates.type === "LINE") {
            this.drawLine(ctx, coordinates)
        }
        if (coordinates.type === "TEXT_LABEL") {
            this.drawText(ctx, coordinates)
        }
        if (coordinates.type === "ANGLE_LABEL") {
            this.drawAngle(ctx, coordinates)
        }
    }

    drawLine(ctx, coordinates) {
        if (!coordinates) return
        let [startPoint, endPoint] = coordinates.points
        ctx.beginPath();
        ctx.moveTo(startPoint.x, startPoint.y);
        ctx.lineTo(endPoint.x, endPoint.y);
        ctx.stroke();
        if (coordinates.lineType === "line") {
            this.drawRay(ctx, startPoint, endPoint)
            this.drawRay(ctx, endPoint, startPoint)
        }
        if (coordinates.lineType === "ray") {
            this.drawRay(ctx, startPoint, endPoint)
        }
    }

    drawPoint(ctx, x, y) {
        ctx.beginPath();
        ctx.arc(x, y, 2, 0, 2 * Math.PI);
        ctx.fill()
    }

    drawRay(ctx, startPoint, endPoint) {
        let headlen = 10; // length of head in pixels
        let dx = endPoint.x - startPoint.x;
        let dy = endPoint.y - startPoint.y;
        let angle = Math.atan2(dy, dx);
        ctx.moveTo(endPoint.x, endPoint.y);
        ctx.lineTo(endPoint.x - headlen * Math.cos(angle - Math.PI / 6), endPoint.y - headlen * Math.sin(angle - Math.PI / 6));
        ctx.moveTo(endPoint.x, endPoint.y);
        ctx.lineTo(endPoint.x - headlen * Math.cos(angle + Math.PI / 6), endPoint.y - headlen * Math.sin(angle + Math.PI / 6))
        ctx.stroke();
    }


    drawText(ctx, coordinates = {}, round = false) {
        for (let i = 0; i < coordinates.points.length; i++) {
            let point = coordinates.points[i]
            let xy = { x: point.x, y: point.y + 15 }
            let rotatePointWithCenter = GeometryUtility.rotatePointWithCenter(xy, point, point.rotationAngle)
            ctx.beginPath();
            ctx.font = "14px Arial";
            ctx.textAlign = "center";
            ctx.fillText(point.label, rotatePointWithCenter.x, rotatePointWithCenter.y);
            ctx.fill()
            ctx.textAlign = "";
            this.drawPoint(ctx, point.x, point.y)
            if (round) {

            }
        }

    }

    drawAngle(ctx, coordinates = {}) {
        let arcRadius = 20
        for (let i = 0; i < coordinates.points.length; i++) {
            let point = coordinates.points[i]
            let xy = { x: point.x + arcRadius + 10, y: point.y }
            let rotatePointWithCenter = GeometryUtility.rotatePointWithCenter(xy, point, (point.startAngle / 2 + (point.rotationAngle || 0)))

            ctx.beginPath();
            ctx.font = "10px Arial";
            ctx.fillText(point.label, rotatePointWithCenter.x, rotatePointWithCenter.y);
            ctx.fill()

            let startAngle = this.toRad(point.startAngle + point.endAngle)
            let rotateAngle = this.toRad(point.rotationAngle || 0)
            let endAngle = this.toRad(-point.endAngle)

            ctx.beginPath();
            ctx.arc(point.x, point.y, arcRadius, startAngle + rotateAngle, endAngle + rotateAngle, true);
            ctx.stroke();
        }
    }

    toRad(Value) {
        return Value * Math.PI / 180;
    }

    rerenderForCanvas() {
        setTimeout(() => {
            if (!this.state.canvasReRender) {
                this.setState({ canvasReRender: true })
            }
        }, 1000)
    }

    render() {
        return (
            <div className="canvas-preview pt-2 pl-2">
                <div className="row">
                    <div className="col text-center">
                        <div id="scroll-1" className="scroll-view" style={{ maxWidth: this.props.divMaxWidth ? this.props.divMaxWidth : "600px" }} >
                            <canvas id={this.props.id} width={this.props.maxWidth > 450 ? this.props.maxWidth : "450"} height={this.props.maxHeight > 400 ? this.props.maxHeight : "400"}>
                            </canvas>
                        </div>
                    </div>
                </div>
                {
                    this.rerenderForCanvas()
                }
            </div >
        );
    }
}

export default CanvasPreview;